import type { ComponentPropsWithoutRef } from "react";
import { twMerge } from "tailwind-merge";

export type SpinnerSize = "sm" | "md" | "lg";

export type SpinnerProps = Omit<ComponentPropsWithoutRef<"svg">, "children"> & {
  size?: SpinnerSize;
};

export type SpinnerContainerProps = ComponentPropsWithoutRef<"div">;

const spinnerSizeClassNames: Record<SpinnerSize, string> = {
  sm: "h-5 w-5",
  md: "h-8 w-8",
  lg: "h-11 w-11",
};

const spinnerStrokeWidths: Record<SpinnerSize, number> = {
  sm: 4,
  md: 4,
  lg: 3,
};

export const Spinner = ({ className, size = "lg", ...props }: SpinnerProps) => {
  return (
    <svg
      {...props}
      className={twMerge(
        "animate-spin motion-reduce:animate-none",
        spinnerSizeClassNames[size],
        className,
      )}
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
    >
      <circle
        className="opacity-25"
        fill="none"
        cx="12"
        cy="12"
        pathLength="100"
        r="10"
        stroke="currentColor"
        strokeDasharray="75 25"
        strokeDashoffset="-25"
        strokeWidth={spinnerStrokeWidths[size]}
      />
      <circle
        className="opacity-75"
        fill="none"
        cx="12"
        cy="12"
        pathLength="100"
        r="10"
        stroke="currentColor"
        strokeDasharray="25 75"
        strokeLinecap="round"
        strokeWidth={spinnerStrokeWidths[size]}
      />
    </svg>
  );
};

export const SpinnerContainer = ({
  className,
  children,
  ...props
}: SpinnerContainerProps) => {
  return (
    <div
      {...props}
      className={twMerge("flex w-full justify-center py-6", className)}
    >
      {children}
    </div>
  );
};
